import { FC, HTMLProps } from 'react';
import * as S from './styles';

interface TextAreaProps extends HTMLProps<HTMLTextAreaElement> {
  error?: string;
}

export const TextArea: FC<TextAreaProps> = ({ error, ...rest }) => (
  <S.Container>
    <S.TextArea {...rest} />
    {error && <S.ErrorMessage>{error}</S.ErrorMessage>}
  </S.Container>
);
